/**
 * Toggle navigation
 */
export function toggleNavigation() {
	const toggles = document.querySelectorAll('.toggle-navigation');

	if (!toggles) {
		return;
	}

	const body = document.querySelector('body');

	toggles.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			body.classList.toggle('navigation-open');
		});
	});
}

/**
 * Toggle submenu
 */
export function toggleSubmenu() {
	const items = document.querySelectorAll(
		'.navigation .menu-item-has-children'
	);

	if (!items) {
		return;
	}

	items.forEach((item) => {
		item.addEventListener('click', (e) => {
			if (
				e.target.parentNode.classList.contains('menu-item-has-children')
			) {
				e.preventDefault();
				e.stopPropagation();
			}

			if (e.target.classList.contains('menu-item-has-children')) {
				e.target.classList.toggle('open');
			}

			e.target.parentNode.classList.toggle('open');
		});
	});
}
